import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-progress-spinner',
  imports: [CommonModule, ProgressSpinnerModule],
  templateUrl: './progress-spinner.component.html',
})
export class ProgressSpinnerComponent {
  @Input() hasBackground: boolean = true;
}
